// @flow

import { isEqual } from 'lodash';
import { useEffect, useRef } from 'react';

/**
 * Memoizes the current version of the deps
 */
const useDeepEqualCompareMemoize = value => {
  const memo = useRef();

  if (!isEqual(value, memo.current)) {
    memo.current = value;
  }

  return memo.current;
};

/**
 * This is like `useEffect` but uses a deep equal to do the comparison
 * Always pass dependencies and don't use primitives as dependencies
 */
const useDeepEqualEffect = (callback: () => void, deps: any) => {
  useEffect(callback, useDeepEqualCompareMemoize(deps));
};

export default useDeepEqualEffect;
